<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">作品管理</span>

    <div style="margin-top:30px;">
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <ul>
      <div v-for="(item, index) in scratch_list" :key="index">
        <li v-if="item.Community != null && value == '已发布'">
          <div class="img_div">
            <img :src="item.Scratch.img_url" />
          </div>

          <p class="title">
            {{ item.Scratch.WorkName }}
            <el-link
              type="primary"
              style="vertical-align: baseline;"
              @click="release(item)"
            >
              发布社区
            </el-link>
          </p>

          <div class="tab_box_button_div">
            <el-button
              icon="el-icon-edit"
              size="mini"
              type="primary"
              @click="edit_scratch(item)"
            >
              编辑
            </el-button>
            <el-button
              icon="el-icon-delete"
              size="mini"
              type="danger"
              @click="delete_but(item.Scratch.Id, index)"
            >
              删除
            </el-button>
          </div>
        </li>

        <li v-if="item.Community == null && value == '未发布'">
          <div class="img_div">
            <img :src="item.Scratch.img_url" />
          </div>

          <p class="title">
            {{ item.Scratch.WorkName }}
            <el-link
              type="primary"
              style="vertical-align: baseline;"
              @click="release(item)"
            >
              发布社区
            </el-link>
          </p>

          <div class="tab_box_button_div">
            <el-button
              icon="el-icon-edit"
              size="mini"
              type="primary"
              @click="edit_scratch(item)"
            >
              编辑
            </el-button>
            <el-button
              icon="el-icon-delete"
              size="mini"
              type="danger"
              @click="delete_but(item.Scratch.Id, index)"
            >
              删除
            </el-button>
          </div>
        </li>
      </div>
    </ul>

    <!-- 发布社区 -->
    <el-dialog
      title="发布社区"
      :visible.sync="release_community"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-radio-group v-model="tag">
        <el-radio label="游戏"> 游戏 </el-radio>
        <el-radio label="动画"> 动画 </el-radio>
        <el-radio label="音乐"> 音乐 </el-radio>
        <el-radio label="模拟"> 模拟 </el-radio>
        <el-radio label="搞笑"> 搞笑 </el-radio>
        <el-radio label="故事"> 故事 </el-radio>
        <el-radio label="互动编程手柄"> 互动编程手柄 </el-radio>
      </el-radio-group>

      <span slot="footer" class="dialog-footer">
        <el-button @click="release_community = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="release_community_is" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import {
  get_scratch_all,
  deleteScratch,
  put_scratch_release_api,
} from "@/api/scratch.js";
import { post_image_url_api } from "@/api/resources.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    loading,
  },
  data() {
    return {
      scratch_list: [],
      release_community: false,
      tag_id: "",
      tag: "",
      options: [
        {
          value: "已发布",
          label: "已发布",
        },
        {
          value: "未发布",
          label: "未发布",
        },
      ],
      value: "已发布",
      loading_ok: "",
    };
  },

  created() {
    get_scratch_all().then((res) => {
      let data = res.data;
      data.forEach((v, i) => {
        post_image_url_api([v.Scratch.ImageId]).then((value) => {
          if (value.data.length) {
            v.Scratch.img_url = "http://" + value.data[0];
            if (data.length - 1 == i) {
              this.loading_ok = false;
              this.scratch_list = data;
            }
          }
        });

        post_image_url_api([v.Scratch.WorkId]).then((value) => {
          if (value.data.length) {
            v.Scratch.work_url = "http://" + value.data[0];
            if (data.length - 1 == i) {
              this.loading_ok = false;
              this.scratch_list = data;
            }
          }
        });
      });
    });
  },

  methods: {
    route_click(type) {
      this.$router.push({ path: type });
    },

    handleCommand(item) {
      console.log(item);
    },

    to_router() {
      this.$router.push({ path: "/edit_home" });
    },

    //删除作品
    delete_but(id, index) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          deleteScratch(id).then(() => {
            this.scratch_list.splice(index, 1);
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    //编辑作品
    edit_scratch(item) {
      var url = "/scratch/?id=" + item.Scratch.Id + "&stageArea=false";
      window.open(url);
    },

    //发布社区
    release(item) {
      this.tag = "";
      this.tag_id = item.Scratch.Id;
      this.release_community = true;
    },

    //发布社区弹框确定按钮
    release_community_is() {
      if (!this.tag) {
        this.$message.error("发布社区类型不能为空！");
        return false;
      }

      put_scratch_release_api(this.tag_id, { tag: this.tag }).then(() => {
        this.$message.success("发布成功！");
        this.release_community = false;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
  ul {
    margin-top:20px;
    width:100%;
     li {
       float:left;
       margin-right:2%;
       margin-bottom:20px;
       width:18%;
       height:240px;
       border:1px solid #eee;
       border-radius:6px;
       position:relative;

       .img_div {
          height:70%;
          width: 100%;
          position: relative;
          overflow:hidden;
          img {
            width:100%;
            position: absolute;
            top:50%;
            left: 50%;
            transform:translate(-50%,-50%);
          }
       }
       .title {
            margin-top:4px;
            text-align:center;
            color:#333;
            font-size:12px;
        }
        .tab_box_button_div {
           width:100%;
           position:absolute;
           bottom: 0%;
           padding:8px 0px;
           display: flex;
           justify-content: space-around;
        }
     }
}
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
